import { SocialLoginOption } from "@redotech/account-common/social-login-option";
import * as z from "zod";
import { portalCustomizationZodSchema } from "./get-portal-customization";

export const portalResourceOverrideSchema = z.object({
  PICKUP_MODAL_MAIN_TEXT: z.string().optional(),
  PICKUP_MODAL_SUB_TEXT: z.string().optional(),
  PICKUP_MODAL_PICKUP_BUTTON_TEXT: z.string().optional(),
  PICKUP_MODAL_SHIPPING_BUTTON_TEXT: z.string().optional(),
  PORTAL_WARRANTY_LINK_TEXT: z.string().optional(),
});

export type PortalResourceOverride = z.infer<
  typeof portalResourceOverrideSchema
>;

export const portalTeamSettingsSchema = z.object({
  socialLoginOptions: z.array(z.enum(SocialLoginOption)).optional(),
  disableRejectedItems: z.boolean().optional(),
  showOtherOption: z.boolean().optional(),
  mailingListSignUpEnabled: z.boolean().optional(),
  requirePhoneNumber: z.boolean().optional(),
  cantFindItemButtonEnabled: z.boolean().optional(),
  askShopperForPricePaid: z.boolean().optional(),
  allowQuantitySelect: z.boolean().optional(),
  maxQuantitySelect: z.number().optional(),
  bulkReturnsEnabled: z.boolean().optional(),
  bulkReturns: z
    .object({
      collections: z.array(z.string()).optional(),
      hideQuantity: z.boolean().optional(),
    })
    .optional(),
  portalExcludedProductTags: z.array(z.string()).optional(),
  portalExcludedProductIds: z.array(z.string()).optional(),
  portalExcludedCollections: z.array(z.string()).optional(),
  portalCollectionBadges: z
    .array(z.object({ collections: z.array(z.string()), text: z.string() }))
    .optional(),
  resourceOverride: portalResourceOverrideSchema.optional(),
});

export type PortalTeamSettings = z.infer<typeof portalTeamSettingsSchema>;

export const updatePortalCustomization = {
  name: "updatePortalCustomization" as const,
  input: z.object({
    customization: portalCustomizationZodSchema,
    teamSettings: portalTeamSettingsSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
